export const createBookingLink = ({ bookingUrl, contact }, query = '') => {
  const url = new URL(bookingUrl)

  if (contact) {
    const { name, email } = contact
    if (name) url.searchParams.set('name', name)
    if (email) url.searchParams.set('email', email)
  }

  if (query) {
    const extraParams = new URLSearchParams(query)
    for (const [key, value] of extraParams) {
      url.searchParams.set(key, value)
    }
  }

  return url.toString()
}
